export default __webpack_public_path__ + "static/media/MH.66639a92.svg";